<div class="oco">
  <header class="oco-header">
    <h1 class="oco-title">Connect OpenClaw to Spectyra</h1>
    <p class="oco-sub">{{ productSubtitle }}</p>
  </header>

  <section class="oco-section">
    <h2 class="oco-h2">Readiness</h2>
    <app-onboarding-checklist [items]="checklist()" />
  </section>

  <section class="oco-section" *ngIf="onboarding.status().state === 'ready'">
    <div class="oco-ready">
      <span class="oco-ready-badge">Spectyra is active</span>
      <p class="oco-mode" *ngIf="onboarding.status().mode as runMode">
        Mode: <strong>{{ runMode }}</strong>
      </p>
      <p class="oco-models" *ngIf="onboarding.status().modelAliases?.length">
        Models: <code>{{ onboarding.status().modelAliases!.join(', ') }}</code>
      </p>
    </div>
  </section>

  <!-- Inline sign-in / sign-up when not authenticated -->
  <section class="oco-section" *ngIf="onboarding.status().state === 'not_signed_in'">
    <div class="oco-auth-card">
      <h2 class="oco-auth-title">{{ authMode === 'login' ? 'Sign in' : 'Create account' }}</h2>
      <p class="oco-auth-desc">
        {{ authMode === 'login'
          ? 'Sign in to sync sessions to the cloud dashboard and see analytics.'
          : 'Create a free Spectyra account to sync sessions and unlock analytics.'
        }}
      </p>

      <form class="oco-auth-form" (ngSubmit)="authMode === 'login' ? doSignIn() : doSignUp()">
        <div class="oco-field">
          <label for="oco-email">Email</label>
          <input id="oco-email" type="email" [(ngModel)]="authEmail" name="email"
                 placeholder="you@example.com" [disabled]="authLoading" required />
        </div>
        <div class="oco-field">
          <label for="oco-pass">Password</label>
          <input id="oco-pass" type="password" [(ngModel)]="authPassword" name="password"
                 placeholder="••••••••" [disabled]="authLoading" required minlength="8" />
        </div>
        <div class="oco-field" *ngIf="authMode === 'register'">
          <label for="oco-org">Organization name</label>
          <input id="oco-org" type="text" [(ngModel)]="authOrgName" name="orgName"
                 placeholder="My Company" [disabled]="authLoading" required />
        </div>
        <div class="oco-auth-error" *ngIf="authError">{{ authError }}</div>
        <button type="submit" class="btn-primary oco-auth-btn"
                [disabled]="authLoading || !authEmail || !authPassword || (authMode === 'register' && !authOrgName)">
          {{ authLoading ? (authMode === 'login' ? 'Signing in…' : 'Creating account…')
                         : (authMode === 'login' ? 'Sign in' : 'Create account') }}
        </button>
      </form>

      <p class="oco-auth-toggle">
        <ng-container *ngIf="authMode === 'login'">
          Don't have an account?
          <button type="button" class="oco-link-btn" (click)="authMode = 'register'; authError = null">Sign up</button>
        </ng-container>
        <ng-container *ngIf="authMode === 'register'">
          Already have an account?
          <button type="button" class="oco-link-btn" (click)="authMode = 'login'; authError = null">Sign in</button>
        </ng-container>
      </p>
    </div>
  </section>

  <!-- Standard action card for all other states -->
  <app-onboarding-action-card
    *ngIf="onboarding.status().state !== 'not_signed_in'"
    [title]="headline().title"
    [body]="headline().body"
    [actions]="onboarding.status().actions"
    [disabled]="onboarding.status().state === 'checking' || onboarding.companionStartBusy()"
    (actionClick)="onAction($event)"
  />

  <app-onboarding-diagnostics
    [diagnostics]="onboarding.lastDiagnostics()"
    [lastRefresh]="onboarding.lastRefreshAt()"
    [companionBaseUrl]="onboarding.lastDiagnostics()?.companionBaseUrl ?? null"
    [modelAliases]="onboarding.lastDiagnostics()?.modelAliases"
    (retry)="onDiagRetry()"
  />
</div>
